import { useEffect } from "react";
import { useLocation } from "react-router-dom";

interface Props {
  title: string;
  description: string;
  keywords?: string;
  type?: "website" | "video.movie" | "article";
}

function upsertMeta(attr: "name" | "property", key: string, content: string) {
  const selector = `meta[${attr}="${key}"]`;
  let element = document.head.querySelector<HTMLMetaElement>(selector);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attr, key);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
}

export default function PageMeta({ title, description, keywords, type = "website" }: Props) {
  const location = useLocation();
  const basePath = __BASE_PATH__.endsWith("/") ? __BASE_PATH__.slice(0, -1) : __BASE_PATH__;
  const canonical = `${window.location.origin}${basePath}${location.pathname}`;

  useEffect(() => {
    document.title = title;
    upsertMeta("name", "description", description);
    if (keywords) upsertMeta("name", "keywords", keywords);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:url", canonical);
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);

    let canonicalLink = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute("href", canonical);
  }, [title, description, keywords, type, canonical]);

  return null;
}